"use strict";
const base = 0;
const above = 1;
const below = -1;
const page = above + base;
const popover = 1000;
const modal = 5000;
const tooltip = 5000 + popover;
const toast = 5500;
const ZIndex = {
    page,
    topBanner: page,
    datePicker: page,
    datePickerPopover: page,
    nestableListDragLayer: 99 + page,
    popover,
    contextMenuPopover: 2000 + popover,
    notification: 3999 + page,
    modal,
    dragLayer: above + modal,
    toast,
    tooltip,
    barChart: below + tooltip,
    checkbox: 4000 + tooltip,
};
module.exports = { ZIndex };
//# sourceMappingURL=constants.js.map